import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Switch, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControlLabel, MenuItem, Checkbox, List, ListItem, ListItemText, ListItemIcon, CircularProgress, Tabs, Tab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { processingAPI, merchantAPI } from '../Api';




const ProcessingList = () => {
  const [items, setItems] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [form, setForm] = useState({ name: '', key: '', apikey: '', clientid: '', emiratesMethodId: '', url: '', status: true, type: 'card', comissionPercent: 0, conversion: 0 });
  const [errors, setErrors] = useState({});
  const [emiratesMethods, setEmiratesMethods] = useState(null);
  const loadEmiratesMethods = async row => {
    setEmiratesMethods({ row, items: [], loading: true, error: '' });
    try {
      const response = await processingAPI.emiratesMethods(row.id);
      if (!Array.isArray(response.data?.data)) throw new Error();
      setEmiratesMethods(current => current?.row.id === row.id ? { ...current, items: response.data.data, loading: false } : current);
    } catch {
      setEmiratesMethods(current => current?.row.id === row.id ? { ...current, loading: false, error: 'Не удалось получить методы. Проверьте API URL, ключ и Callback Secret.' } : current);
    }
  };
  const chooseEmiratesMethod = async method => {
    const row = emiratesMethods.row;
    setEmiratesMethods(current => ({ ...current, loading: true }));
    try {
      const response = await processingAPI.update(row.id, { emiratesMethodId: method.id });
      if (response.data?.success !== true) throw new Error();
      setItems(current => current.map(item => item.id === row.id ? { ...item, emiratesMethodId: method.id } : item));
      setEmiratesMethods(null);
    } catch { setEmiratesMethods(current => ({ ...current, loading: false, error: 'Не удалось сохранить метод.' })); }
  };
  const [loading, setLoading] = useState(false);
  const [reordering, setReordering] = useState(false);
  const [assignOpen, setAssignOpen] = useState(false);
  const [assignTarget, setAssignTarget] = useState(null); // row object
  const [assignRows, setAssignRows] = useState([]); // [{id, name, site, checked, comissionEnabled, comissionPercent}]
  const [assignLoading, setAssignLoading] = useState(false);
  const [assignSaving, setAssignSaving] = useState(false);
  const [activeTab, setActiveTab] = useState('card');

  const toggleStatus = async (id) => {
    const current = items.find(i => i.id === id);
    if (!current) return;
    const nextStatus = !current.status;
    setItems(prev => prev.map(it => it.id === id ? { ...it, status: nextStatus } : it));
    try {
      await processingAPI.update(id, { status: nextStatus });
    } catch (e) {
      // rollback on error
      setItems(prev => prev.map(it => it.id === id ? { ...it, status: !nextStatus } : it));
    }
  };

  // Merchants assignment
  const handleOpenAssign = async (row) => {
    setAssignTarget(row);
    setAssignSaving(false);
    setAssignOpen(true);
    setAssignLoading(true);
    try {
      const [merchListRes, assignedRes] = await Promise.all([
        merchantAPI.getMerchant(),
        processingAPI.getMerchants(row.id),
      ]);
      const all = merchListRes.data?.data || [];
      const assigned = (assignedRes.data?.data || []);
      const assignedMap = new Map(assigned.map(m => [String(m._id || m.id), m]));
      const rows = all.map(m => {
        const id = m._id || m.id;
        const a = assignedMap.get(String(id));
        return {
          id,
          name: m.name,
          site: m.site,
          checked: !!a, // assigned to this processing
          comissionEnabled: !!(a && a.comissionEnabled),
          comissionPercent: a && a.comission != null ? (Number(a.comission) - 1) * 100 : 0,
        };
      });
      setAssignRows(rows);
    } catch (e) {
      setAssignRows([]);
    } finally {
      setAssignLoading(false);
    }
  };
  const handleCloseAssign = () => {
    setAssignOpen(false);
    setAssignTarget(null);
    setAssignRows([]);
    setAssignSaving(false);
  };
  const toggleSelectMerchant = (id) => {
    setAssignRows(prev => prev.map(r => r.id === id ? { ...r, checked: !r.checked } : r));
  };
  const handleAssignCommissionToggle = (id) => {
    setAssignRows(prev => prev.map(r => r.id === id ? { ...r, comissionEnabled: !r.comissionEnabled } : r));
  };
  const handleAssignCommissionChange = (id, value) => {
    setAssignRows(prev => prev.map(r => r.id === id ? { ...r, comissionPercent: value } : r));
  };
  const handleSaveAssign = async () => {
    if (!assignTarget) return;
    setAssignSaving(true);
    try {
      // Build payload with commission per selected merchant
      const payload = assignRows.filter(r => r.checked).map(r => ({
        merchantId: r.id,
        comissionEnabled: !!r.comissionEnabled,
        comissionPercent: Number(r.comissionPercent || 0),
      }));
      await processingAPI.setMerchants(assignTarget.id, payload);
      handleCloseAssign();
    } catch (e) {
      setAssignSaving(false);
    } finally {
      // Ensure flag reset if dialog stays open due to some edge case
      setAssignSaving(false);
    }
  };

  const handleOpenAdd = () => {
    setForm({ name: '', key: '', proc: '', apikey: '', clientid: '', emiratesMethodId: '', url: '', status: true, type: activeTab, comissionPercent: 0, conversion: 0, group: '' });
    setErrors({});
    setOpenAdd(true);
  };
  const handleCloseAdd = () => setOpenAdd(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };
  const handleToggleStatus = (e) => setForm(prev => ({ ...prev, status: e.target.checked }));
  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = 'Обязательно';
    if (!form.key.trim()) errs.key = 'Обязательно';
    if (!form.url.trim()) errs.url = 'Обязательно';
    if (/^emirates(?:_|$)|^savagepay/.test(form.key)) {
      if (!form.apikey.trim()) errs.apikey = 'Введите Merchant API Key';
      if (!form.clientid.trim()) errs.clientid = 'Введите Callback Secret';
    }
    if (/^emirates(?:_|$)/.test(form.key) && form.status && !/^[A-Za-z0-9_-]{1,128}$/.test(form.emiratesMethodId)) errs.emiratesMethodId = 'Введите ID метода или сохраните выключенным для выбора из API';
    if (form.comissionPercent < 0) errs.comissionPercent = 'Не может быть меньше 0%';
    if (form.conversion < 0 || form.conversion > 100) errs.conversion = 'Должно быть от 0 до 100';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };
  const handleSave = () => {
    if (!validate()) return;
    const payload = {
      name: form.name.trim(),
      key: form.key.trim(),
      proc: form.proc.trim() || undefined,
      apikey: form.apikey.trim(),
      clientid: form.clientid.trim(),
      ...(/^emirates(?:_|$)/.test(form.key) ? { emiratesMethodId: form.emiratesMethodId.trim() } : {}),
      url: form.url.trim(),
      status: form.status,
      type: form.type,
      comission: 1 + Number(form.comissionPercent || 0) / 100,
      conversion: Number(form.conversion || 0),
      group: form.group.trim() || null,
    };
    processingAPI.create(payload)
      .then(res => {
        const created = res.data?.data || {};
        const mapped = {
          id: created._id || created.id,
          name: created.name,
          key: created.key,
          proc: created.proc,
          apikey: created.apikey,
          clientid: created.clientid,
          emiratesMethodId: created.emiratesMethodId,
          url: created.url,
          status: created.status,
          type: created.type,
          comission: created.comission, // multiplier in DB
          comissionPercent: created.comission != null ? (Number(created.comission) - 1) * 100 : 0,
          accepted: created.amount ?? 0,
          conversion: created.conversion ?? 0,
        };
        setItems(prev => [mapped, ...prev]);
        setOpenAdd(false);
      })
      .catch(() => {
        // опционально: показать ошибку
      });
  };

  useEffect(() => {
    setLoading(true);
    processingAPI.getList()
      .then(res => {
        const list = res.data?.data || [];
        const mapped = list.map(x => ({
          id: x._id || x.id,
          name: x.name,
          key: x.key,
          proc: x.proc,
          apikey: x.apikey,
          clientid: x.clientid,
          emiratesMethodId: x.emiratesMethodId,
          url: x.url,
          status: x.status,
          type: x.type,
          comission: x.comission,
          comissionPercent: x.comission != null ? (Number(x.comission) - 1) * 100 : 0,
          accepted: x.amount ?? 0,
          conversion: x.conversion ?? 0,
        }));
        setItems(mapped);
      })
      .finally(() => setLoading(false));
  }, []);

  const typeLabels = {
    card: 'Карта',
    cardsng: 'Карта (СНГ)',
    crypto: 'Крипто',
    p2purl: 'URL',
  };
  const types = ['card', 'cardsng', 'crypto', 'p2purl'];
  const counts = types.reduce((acc, t) => {
    acc[t] = items.filter(i => i.type === t).length;
    return acc;
  }, {});

  const persistOrder = (newItems) => {
    setReordering(true);
    const order = newItems.map(i => i.id);
    processingAPI.reorder(order).then(res => {
      const list = res.data?.data || [];
      const mapped = list.map(x => ({
        id: x._id || x.id,
        name: x.name,
        key: x.key,
        apikey: x.apikey,
        clientid: x.clientid,
        emiratesMethodId: x.emiratesMethodId,
        url: x.url,
        status: x.status,
        type: x.type,
        comission: x.comission,
        comissionPercent: x.comission != null ? (Number(x.comission) - 1) * 100 : 0,
        accepted: x.amount ?? 0,
        conversion: x.conversion ?? 0,
      }));
      setItems(mapped);
    }).finally(() => setReordering(false));
  };

  const handleRowComissionChange = (id, value) => {
    setItems(prev => prev.map(it => it.id === id ? { ...it, comissionPercent: value } : it));
  };

  const handleRowComissionBlur = async (id) => {
    const row = items.find(i => i.id === id);
    if (!row) return;
    const p = Number(row.comissionPercent || 0);
    try {
      const res = await processingAPI.update(id, { comissionPercent: p });
      const updated = res.data?.data;
      if (updated) {
        setItems(prev => prev.map(i => i.id === id ? {
          ...i,
          comission: updated.comission,
          comissionPercent: (Number(updated.comission) - 1) * 100,
        } : i));
      }
    } catch (e) {
      // no-op; could show error
    }
  };

  const handleRowProcChange = (id, value) => {
    setItems(prev => prev.map(it => it.id === id ? { ...it, proc: value } : it));
  };

  const handleRowProcBlur = async (id) => {
    const row = items.find(i => i.id === id);
    if (!row) return;
    try {
      const res = await processingAPI.update(id, { proc: row.proc || null });
      const updated = res.data?.data;
      if (updated) {
        setItems(prev => prev.map(i => i.id === id ? {
          ...i,
          proc: updated.proc,
        } : i));
      }
    } catch (e) {
      // no-op; could show error
    }
  };

  const handleRowConversionChange = (id, value) => {
    setItems(prev => prev.map(it => it.id === id ? { ...it, conversion: value } : it));
  };

  const handleRowConversionBlur = async (id) => {
    const row = items.find(i => i.id === id);
    if (!row) return;
    const c = Number(row.conversion || 0);
    if (c < 0 || c > 100) return;
    try {
      const res = await processingAPI.update(id, { conversion: c });
      const updated = res.data?.data;
      if (updated) {
        setItems(prev => prev.map(i => i.id === id ? {
          ...i,
          conversion: updated.conversion ?? 0,
        } : i));
      }
    } catch (e) {
      // no-op; could show error
    }
  };

  const moveUp = (id) => {
    setItems(prev => {
      const idx = prev.findIndex(i => i.id === id);
      if (idx <= 0) return prev;
      const next = [...prev];
      [next[idx - 1], next[idx]] = [next[idx], next[idx - 1]];
      persistOrder(next);
      return next;
    });
  };

  const moveDown = (id) => {
    setItems(prev => {
      const idx = prev.findIndex(i => i.id === id);
      if (idx === -1 || idx >= prev.length - 1) return prev;
      const next = [...prev];
      [next[idx + 1], next[idx]] = [next[idx], next[idx + 1]];
      persistOrder(next);
      return next;
    });
  };

  return (
    <Box sx={{ mt: 8, p: 4, boxShadow: 3, borderRadius: 2, bgcolor: '#fefcfb' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h5">
          Платежные методы
        </Typography>
        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          sx={{ bgcolor: '#683d62', '&:hover': { bgcolor: '#5a3455' } }}
          onClick={handleOpenAdd}
        >
          Добавить
        </Button>
      </Box>

      <Tabs
        value={activeTab}
        onChange={(e, v) => setActiveTab(v)}
        sx={{ mb: 2 }}
      >
        {types.map(t => (
          <Tab key={t} value={t} label={`${typeLabels[t]} (${counts[t] || 0})`} />
        ))}
      </Tabs>

      <Dialog open={openAdd} onClose={handleCloseAdd} fullWidth maxWidth="sm">
        <DialogTitle>Добавить платежный метод</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <TextField
            label="Имя"
            name="name"
            value={form.name}
            onChange={handleChange}
            fullWidth
            margin="normal"
            error={!!errors.name}
            helperText={errors.name}
          />
          <TextField
            label="Тип"
            name="type"
            value={form.type}
            onChange={handleChange}
            select
            fullWidth
            margin="normal"
          >
            <MenuItem value="card">Карта</MenuItem>
            <MenuItem value="cardsng">Карта (СНГ)</MenuItem>
            <MenuItem value="crypto">Крипто</MenuItem>
            <MenuItem value="p2purl">URL</MenuItem>
          </TextField>
          <TextField
            label="Ключ"
            name="key"
            value={form.key}
            onChange={handleChange}
            fullWidth
            margin="normal"
            error={!!errors.key}
            helperText={errors.key}
          />
          <TextField
            label="Proc ID (уникальный идентификатор)"
            name="proc"
            value={form.proc}
            onChange={handleChange}
            fullWidth
            margin="normal"
            helperText="Опционально. Уникальный идентификатор процессинга"
          />
          <TextField
            label="Комиссия (%)"
            name="comissionPercent"
            type="number"
            value={form.comissionPercent}
            onChange={handleChange}
            fullWidth
            margin="normal"
            inputProps={{ step: 0.1, min: 0 }}
            error={!!errors.comissionPercent}
            helperText={errors.comissionPercent}
          />
          <TextField
            label="Конверсия (%)"
            name="conversion"
            type="number"
            value={form.conversion}
            onChange={handleChange}
            fullWidth
            margin="normal"
            inputProps={{ step: 0.1, min: 0, max: 100 }}
            error={!!errors.conversion}
            helperText={errors.conversion}
          />
          <TextField
            label="API Key"
            name="apikey"
            type={/^emirates(?:_|$)|^savagepay/.test(form.key) ? 'password' : 'text'}
            value={form.apikey}
            error={!!errors.apikey}
            helperText={errors.apikey}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label={/^savagepay/.test(form.key) ? 'Callback Secret SavagePay' : /^emirates(?:_|$)/.test(form.key) ? 'Callback Secret Emirates' : 'Client ID'}
            name="clientid"
            type={/^emirates(?:_|$)|^savagepay/.test(form.key) ? 'password' : 'text'}
            value={form.clientid}
            error={!!errors.clientid}
            helperText={errors.clientid || (/^savagepay/.test(form.key) ? 'Секрет подписи callback из кабинета SavagePay. Тип: card. URL: https://savagepay.org/api/v1' : '')}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          {/^emirates(?:_|$)/.test(form.key) && <TextField label="Method ID Emirates"
            name="emiratesMethodId" value={form.emiratesMethodId} onChange={handleChange}
            fullWidth margin="normal" error={!!errors.emiratesMethodId}
            helperText={errors.emiratesMethodId || 'ID из GET /api/v1/merchant/methods. Можно сохранить выключенным и выбрать через «Методы Emirates». Для СБП — тип card. URL — адрес API.'} />}
          <TextField
            label="URL"
            name="url"
            value={form.url}
            onChange={handleChange}
            fullWidth
            margin="normal"
            error={!!errors.url}
            helperText={errors.url}
          />
          <FormControlLabel
            control={<Switch checked={form.status} onChange={handleToggleStatus} />}
            label={form.status ? 'Включено' : 'Выключено'}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAdd}>Отмена</Button>
          <Button variant="contained" onClick={handleSave} sx={{ bgcolor: '#683d62', '&:hover': { bgcolor: '#5a3455' } }}>Сохранить</Button>
        </DialogActions>
      </Dialog>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Имя</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Ключ</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Proc ID</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Тип</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Комиссия (%)</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Конверсия (%)</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Принято</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Статус</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Мерчанты</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Позиция</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.filter(r => r.type === activeTab).map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.key}{/^emirates(?:_|$)/.test(row.key) && <>
                  <Typography variant="caption" display="block">{row.emiratesMethodId || 'Метод не выбран'}</Typography>
                  <Button size="small" onClick={() => loadEmiratesMethods(row)}>Методы Emirates</Button>
                </>}</TableCell>
                <TableCell>
                  <TextField
                    value={row.proc || ''}
                    onChange={(e) => handleRowProcChange(row.id, e.target.value)}
                    onBlur={() => handleRowProcBlur(row.id)}
                    placeholder="Не задан"
                    size="small"
                    sx={{ width: 150 }}
                  />
                </TableCell>
                <TableCell>{row.type === 'crypto' ? 'Крипто' : row.type === 'p2purl' ? 'URL' : row.type === 'cardsng' ? 'Карта (СНГ)' : 'Карта'}</TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    value={Number(row.comissionPercent ?? 0).toFixed(1)}
                    onChange={(e) => handleRowComissionChange(row.id, e.target.value)}
                    onBlur={() => handleRowComissionBlur(row.id)}
                    inputProps={{ step: 0.1, min: 0 }}
                    size="small"
                    sx={{ width: 100 }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    value={Number(row.conversion ?? 0).toFixed(1)}
                    onChange={(e) => handleRowConversionChange(row.id, e.target.value)}
                    onBlur={() => handleRowConversionBlur(row.id)}
                    inputProps={{ step: 0.1, min: 0, max: 100 }}
                    size="small"
                    sx={{ width: 100 }}
                  />
                </TableCell>
                <TableCell>{row.accepted}</TableCell>
                <TableCell>
                  <Switch
                    checked={row.status}
                    onChange={() => toggleStatus(row.id)}
                    color="primary"
                    inputProps={{ 'aria-label': 'toggle status' }}
                  />
                  {row.status ? ' Включено' : ' Выключено'}
                </TableCell>
                <TableCell>
                  <Button variant="outlined" size="small" onClick={() => handleOpenAssign(row)}>Настроить</Button>
                </TableCell>
                <TableCell>
                  <Button size="small" onClick={() => moveUp(row.id)} disabled={reordering}>
                    <ArrowUpwardIcon fontSize="inherit" />
                  </Button>
                  <Button size="small" onClick={() => moveDown(row.id)} disabled={reordering}>
                    <ArrowDownwardIcon fontSize="inherit" />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={!!emiratesMethods} onClose={() => !emiratesMethods?.loading && setEmiratesMethods(null)} fullWidth maxWidth="sm">
        <DialogTitle>Методы Emirates · {emiratesMethods?.row.name}</DialogTitle>
        <DialogContent>
          {emiratesMethods?.loading && <CircularProgress size={24} />}
          {emiratesMethods?.error && <Typography color="error">{emiratesMethods.error}</Typography>}
          {emiratesMethods?.items.map(method => <Box key={method.id} sx={{ mb: 2 }}>
            <Typography>{method.name} · {method.code} · {method.currency}</Typography>
            <Typography variant="caption">{method.id} · {method.minPayin}–{method.maxPayin}</Typography>
            <Button disabled={emiratesMethods.loading || method.currency !== 'RUB'} onClick={() => chooseEmiratesMethod(method)}>Выбрать</Button>
          </Box>)}
        </DialogContent>
        <DialogActions><Button disabled={emiratesMethods?.loading} onClick={() => setEmiratesMethods(null)}>Закрыть</Button></DialogActions>
      </Dialog>
      {/* Assign merchants dialog */}
      <Dialog open={assignOpen} onClose={handleCloseAssign} fullWidth maxWidth="sm">
        <DialogTitle>Доступ мерчантов {assignTarget ? `— ${assignTarget.name}` : ''}</DialogTitle>
        <DialogContent dividers>
          {assignLoading ? (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 3 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <List dense>
              {assignRows.map((m) => (
                <ListItem key={m.id}>
                  <ListItemIcon>
                    <Checkbox edge="start" checked={m.checked} onChange={() => toggleSelectMerchant(m.id)} tabIndex={-1} disableRipple />
                  </ListItemIcon>
                  <ListItemText primary={m.name} secondary={m.site} />
                  {/* Commission controls */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Button size="small" variant={m.comissionEnabled ? 'contained' : 'outlined'} onClick={() => handleAssignCommissionToggle(m.id)}>
                      {m.comissionEnabled ? 'Комиссия вкл' : 'Комиссия выкл'}
                    </Button>
                    <TextField
                      type="number"
                      size="small"
                      value={Number(m.comissionPercent ?? 0)}
                      onChange={(e) => handleAssignCommissionChange(m.id, e.target.value)}
                      inputProps={{ step: 0.1, min: 0 }}
                      sx={{ width: 110 }}
                      disabled={!m.comissionEnabled}
                    />
                  </Box>
                </ListItem>
              ))}
              {(!assignRows || assignRows.length === 0) && (
                <Typography variant="body2" color="text.secondary">Нет мерчантов</Typography>
              )}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAssign} disabled={assignSaving}>Отмена</Button>
          <Button variant="contained" onClick={handleSaveAssign} disabled={assignSaving} sx={{ bgcolor: '#683d62', '&:hover': { bgcolor: '#5a3455' } }}>
            {assignSaving ? 'Сохранение...' : 'Сохранить'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ProcessingList;
